import { render, staticRenderFns } from "./LabelsNew.vue?vue&type=template&id=5039d404&scoped=true"
import script from "./LabelsNew.vue?vue&type=script&lang=js"
export * from "./LabelsNew.vue?vue&type=script&lang=js"
import style0 from "./LabelsNew.vue?vue&type=style&index=0&id=5039d404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5039d404",
  null
  
)

export default component.exports